const msalConfig = {
  auth: {
    clientId: process.env.AZURE_AD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.AZURE_AD_TENANT_ID}`,
    navigateToLoginRequestUrl: false,
    redirectUri: process.env.AZURE_AD_REDIRECT_URI,
    postLogoutRedirectUri: process.env.AZURE_AD_REDIRECT_URI
  },
  cache: {
		cacheLocation: "localStorage",
	}
};

const loginScope = {
  scopes: [process.env.AZURE_AD_SCOPE]
};

export { msalConfig, loginScope };
